import { z } from 'zod'

/**
 * Valkyrie `POST /v1/channels/{channel}/uploads` — UploadResult.
 * Mirrors `UploadChannelPosUseCase.UploadResult` unchanged.
 */
export const UploadVisionIssueSchema = z.object({
  code: z.string(),
  severity: z.string(),
  message: z.string().optional().nullable(),
})

export const UploadParseErrorSchema = z.object({
  poNumber: z.string().optional().nullable(),
  message: z.string(),
  sourceLine: z.number().int().optional().nullable(),
})

export const UploadPoResultSchema = z.object({
  poNumber: z.string(),
  outcome: z.string(),
  visionResult: z.string().optional().nullable(),
  issues: z.array(UploadVisionIssueSchema).default([]),
})

export const UploadFileResultSchema = z.object({
  filename: z.string(),
  pos: z.array(UploadPoResultSchema).default([]),
  parseErrors: z.array(UploadParseErrorSchema).default([]),
})

export const UploadResultSchema = z.object({
  tenantId: z.string(),
  accepted: z.number().int(),
  skipped: z.number().int(),
  hold: z.number().int(),
  fail: z.number().int(),
  parseErrorCount: z.number().int(),
  files: z.array(UploadFileResultSchema).default([]),
})

export type UploadVisionIssue = z.infer<typeof UploadVisionIssueSchema>
export type UploadParseError = z.infer<typeof UploadParseErrorSchema>
export type UploadPoResult = z.infer<typeof UploadPoResultSchema>
export type UploadFileResult = z.infer<typeof UploadFileResultSchema>
export type UploadResult = z.infer<typeof UploadResultSchema>

export const UPLOAD_CHANNELS = [
  'blinkit',
  'flipkart',
  'flipkart_minutes',
  'myntra',
  'ajio',
  'bbnow',
  'instamart',
  'offline_b2b',
] as const
export type UploadChannel = (typeof UPLOAD_CHANNELS)[number]

export const DEFAULT_UPLOAD_CHANNEL: UploadChannel = 'flipkart'
export const IMPLEMENTED_UPLOAD_CHANNELS: readonly UploadChannel[] = [
  'blinkit',
  'flipkart',
  'flipkart_minutes',
  'myntra',
  'ajio',
  'bbnow',
  'instamart',
  'offline_b2b',
]
